declare const moment: any;

export class Amenity {

    static fromBookingData(booking: any): Amenity {
        const amenity = new Amenity();
        if (booking.building) amenity.buildingId = +booking.building.bdId;
        if (booking.building) amenity.buildingName = booking.building.name;
        if (booking.building) amenity.buildingTimezone = booking.building.timezone;
        if (booking.id) amenity.id = booking.id;
        if (booking.otherResident) amenity.otherResident = booking.otherResident;
        if (booking.otherSuite) amenity.otherSuite = booking.otherSuite;
        if (booking.resident) amenity.residentId = +booking.resident.bdId;
        if (booking.resident) amenity.residentFullName = booking.resident.fullName;
        if (booking.resident) amenity.residentEmail = booking.resident.email;
        if (booking.resident) amenity.isValidEmail = booking.resident.isValidEmail;
        if (booking.suite) amenity.suiteId = booking.suite.bdId;
        if (booking.suite) amenity.suiteNumber = booking.suite.suiteNumber;
        if (booking.createdBy) amenity.createdBy = booking.createdBy.fullName;
        if (booking.createdAt) amenity.createdAt = booking.createdAt;
        if (booking.status) amenity.status = booking.status;
        if (booking.bookingNumber) amenity.bookingNumber = booking.bookingNumber;
        if (booking.amenity) amenity.amenity = booking.amenity;
        if (booking.amenity) amenity.amenityId = booking.amenity.id;
        if (booking.amenity) amenity.amenityName = booking.amenity.name;
        if (booking.dateFrom) amenity.dateFrom = booking.dateFrom;
        if (booking.dateTo) amenity.dateTo = booking.dateTo;
        if (booking.notes) amenity.notes = booking.notes;
        if (booking.payments) amenity.payments = booking.payments;
        if (booking.uses) amenity.uses = booking.uses;
        if (booking.stripePayments) amenity.stripePayments = booking.stripePayments;
        if (booking.isEvent) amenity.isEvent = booking.isEvent;
        if (booking.event) amenity.event = booking.event;
        if (booking.managementOverride) amenity.managementOverride = booking.managementOverride;
        if (booking.customRefundableHoldDate) amenity.customRefundableHoldDate = moment(booking.customRefundableHoldDate)._d;
        if (booking.customRefundableReleaseDate) amenity.customRefundableReleaseDate = moment(booking.customRefundableReleaseDate)._d;
        amenity.isCanEdit = booking.isCanEdit;
        amenity.isCanDelete = booking.isCanDelete;
        amenity.isCanApprove = booking.isCanApprove;

        return amenity;
    }

    static fromMaintenanceBookingData(booking): Amenity {
        const amenity = new Amenity();
        if (booking.building) amenity.buildingId = +booking.building.bdId;
        if (booking.building) amenity.buildingName = booking.building.name;
        if (booking.id) amenity.id = booking.id;
        if (booking.otherResident) amenity.otherResident = booking.otherResident;
        if (booking.otherSuite) amenity.otherSuite = booking.otherSuite;
        if (booking.resident) amenity.residentId = +booking.resident.bdId;
        if (booking.resident) amenity.residentFullName = booking.resident.fullName;
        if (booking.resident) amenity.isValidEmail = booking.resident.isValidEmail;
        if (booking.suite) amenity.suiteId = booking.suite.bdId;
        if (booking.suite) amenity.suiteNumber = booking.suite.suiteNumber;
        if (booking.createdBy) amenity.createdBy = booking.createdBy.fullName;
        if (booking.createdAt) amenity.createdAt = booking.createdAt;
        if (booking.status) amenity.status = booking.status;
        if (booking.bookingNumber) amenity.bookingNumber = booking.bookingNumber;
        if (booking.amenity) amenity.amenityId = booking.amenity.id;
        if (booking.amenity) amenity.amenityName = booking.amenity.name;
        if (booking.dateFrom) amenity.dateFrom = booking.dateFrom;
        if (booking.dateTo) amenity.dateTo = booking.dateTo;
        if (booking.notes) amenity.notes = booking.notes;
        if (booking.payments) amenity.payments = booking.payments;
        if (booking.uses) amenity.uses = booking.uses;
        if (booking.stripePayments) amenity.stripePayments = booking.stripePayments;
        amenity.isCanEdit = booking.isCanEdit;
        amenity.isCanDelete = booking.isCanDelete;
        amenity.isCanApprove = booking.isCanApprove;
        return amenity;
    }

    constructor(
        public checked: boolean = false,
        public id: number = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public buildingTimezone: string = '',
        public residentId: number = null,
        public residentFullName: string = '',
        public residentEmail: string = '',
        public otherResident: string = '',
        public otherSuite: string = '',
        public amenity: any = null,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public isCanApprove: boolean = true,
        public day: string = '',
        public endDay: string = '',
        public notes: any = null,
        public acknowledgement: boolean = false,
        public emailNotification: boolean = false,
        public payments: any = null,
        public stripePayments: any = null,
        public createdBy: string = '',
        public createdAt: string = '',
        public bookingNumber: string = '',
        public status: string = '',
        public amenityId: number = null,
        public amenityName: string = '',
        public paymentMethod: string = '',
        public paid: boolean = false,
        public dateFrom: string = '',
        public dateTo: string = '',
        public uses: string = '',
        public managementOverride: boolean = false,
        public isValidEmail: boolean = false,
        public isEvent: boolean = false,
        public isPayByLink: boolean = false,
        public event: any = null,
        public customRefundableHoldDate: string = '',
        public customRefundableReleaseDate: string = '',
        public formFields = {
            uses: {editMode: false}
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Amenity.ts